module.exports = __webpack_public_path__ + "img/icon6.b5c24f1b.png";